/** Interface strings of the operator console "Users" tab. */
export const adminUsersMessages = {
  "admin.tabs.users": { ru: "Пользователи", en: "Users" },
  "admin.denied.users": {
    ru: "У вашей сессии нет права users.read, поэтому раздел пользователей недоступен.",
    en: "Your session lacks the users.read permission, so the users section is unavailable.",
  },
  "admin.users.title": { ru: "Пользователи", en: "Users" },
  "admin.users.notice": {
    ru: "Только технические данные: идентификаторы, счётчики, состояния и размеры. Содержимое пользователей не показывается.",
    en: "Technical data only: ids, counts, states and sizes. User content is never shown.",
  },
  "admin.users.search.label": {
    ru: "ID, Telegram ID или @username",
    en: "ID, Telegram ID or @username",
  },
  "admin.users.search.placeholder": {
    ru: "0192a, 123456789, @name",
    en: "0192a, 123456789, @name",
  },
  "admin.users.search.submit": { ru: "Найти", en: "Search" },
  "admin.users.search.invalid": {
    ru: "Допустимы буквы, цифры, дефис, подчёркивание и @ в начале (до 64 знаков).",
    en: "Letters, digits, dash, underscore and a leading @ are allowed (up to 64).",
  },
  "admin.users.status.label": { ru: "Статус", en: "Status" },
  "admin.users.status.any": { ru: "Любой статус", en: "Any status" },
  "admin.users.list.caption": { ru: "Список пользователей", en: "User list" },
  "admin.users.col.user": { ru: "Пользователь", en: "User" },
  "admin.users.col.status": { ru: "Статус", en: "Status" },
  "admin.users.col.plan": { ru: "Тариф", en: "Plan" },
  "admin.users.col.requests": { ru: "Запросы за 30 дн.", en: "Requests 30d" },
  "admin.users.col.activity": {
    ru: "Последняя активность",
    en: "Last activity",
  },
  "admin.users.empty": {
    ru: "Пользователи не найдены.",
    en: "No users found.",
  },
  "admin.users.loading": {
    ru: "Загрузка пользователей",
    en: "Loading users",
  },
  "admin.users.failed": {
    ru: "Не удалось загрузить пользователей.",
    en: "Users could not be loaded.",
  },
  "admin.users.more": { ru: "Показать ещё", en: "Load more" },
  "admin.users.open": { ru: "Открыть", en: "Open" },
  "admin.users.back": { ru: "К списку пользователей", en: "Back to users" },
  "admin.users.detail.loading": {
    ru: "Загрузка пользователя",
    en: "Loading user",
  },
  "admin.users.detail.failed": {
    ru: "Не удалось загрузить пользователя.",
    en: "The user could not be loaded.",
  },
  "admin.users.showLogs": {
    ru: "Показать логи пользователя",
    en: "Show this user's logs",
  },
  "admin.users.none": { ru: "нет", en: "none" },

  "admin.users.profile.title": { ru: "Профиль", en: "Profile" },
  "admin.users.profile.status": { ru: "Статус", en: "Status" },
  "admin.users.profile.locale": { ru: "Язык", en: "Locale" },
  "admin.users.profile.timezone": { ru: "Часовой пояс", en: "Time zone" },
  "admin.users.profile.created": { ru: "Создан", en: "Created" },
  "admin.users.profile.workspaces": {
    ru: "Рабочие пространства",
    en: "Workspaces",
  },
  "admin.users.profile.abilities": { ru: "Способности", en: "Abilities" },

  "admin.users.activity.title": { ru: "Активность", en: "Activity" },
  "admin.users.activity.window": { ru: "Период", en: "Window" },
  "admin.users.activity.w24h": { ru: "24 часа", en: "24 hours" },
  "admin.users.activity.w7d": { ru: "7 дней", en: "7 days" },
  "admin.users.activity.w30d": { ru: "30 дней", en: "30 days" },
  "admin.users.activity.byState": {
    ru: "Задания по состоянию",
    en: "Jobs by state",
  },
  "admin.users.activity.byKind": {
    ru: "Задания по виду запроса",
    en: "Jobs by request kind",
  },
  "admin.users.activity.sessions": { ru: "Сессии", en: "Sessions" },
  "admin.users.activity.feedbackUp": {
    ru: "Отзывы: положительные",
    en: "Feedback: up",
  },
  "admin.users.activity.feedbackDown": {
    ru: "Отзывы: отрицательные",
    en: "Feedback: down",
  },
  "admin.users.activity.recent": {
    ru: "Последние задания",
    en: "Last jobs",
  },
  "admin.users.activity.noJobs": { ru: "Заданий нет.", en: "No jobs." },
  "admin.users.job.id": { ru: "Задание", en: "Job" },
  "admin.users.job.state": { ru: "Состояние", en: "State" },
  "admin.users.job.created": { ru: "Создано", en: "Created" },
  "admin.users.job.logs": { ru: "Логи", en: "Logs" },
  "admin.users.job.openLogs": { ru: "Открыть логи", en: "Open logs" },

  "admin.users.storage.title": { ru: "Хранилище", en: "Storage" },
  "admin.users.storage.notice": {
    ru: "Только технические размеры и счётчики, без содержимого.",
    en: "Technical sizes and counts only, never content.",
  },
  "admin.users.storage.totalAbilities": {
    ru: "Способностей",
    en: "Abilities",
  },
  "admin.users.storage.totalRecords": { ru: "Записей", en: "Records" },
  "admin.users.storage.totalBytes": { ru: "Всего", en: "Total size" },
  "admin.users.storage.itemsCaption": {
    ru: "Хранилища пользователя",
    en: "User stores",
  },
  "admin.users.storage.abilitiesCaption": {
    ru: "Способности пользователя",
    en: "User abilities",
  },
  "admin.users.storage.col.store": { ru: "Хранилище", en: "Store" },
  "admin.users.storage.col.count": { ru: "Записей", en: "Count" },
  "admin.users.storage.col.size": { ru: "Размер", en: "Size" },
  "admin.users.storage.col.updated": { ru: "Обновлено", en: "Updated" },
  "admin.users.storage.col.ability": { ru: "Способность", en: "Ability" },
  "admin.users.storage.col.status": { ru: "Статус", en: "Status" },
  "admin.users.storage.col.lastRecord": {
    ru: "Последняя запись",
    en: "Last record",
  },
  "admin.users.storage.noAbilities": {
    ru: "Способностей нет.",
    en: "No abilities.",
  },
  "users.storage.ability_records": {
    ru: "Записи способностей",
    en: "Ability records",
  },
  "users.storage.assistant_memory": {
    ru: "Память ассистента",
    en: "Assistant memory",
  },
  "users.storage.assistant_sessions": {
    ru: "Сессии ассистента",
    en: "Assistant sessions",
  },

  "admin.users.billing.title": { ru: "Биллинг", en: "Billing" },
  "admin.users.billing.redacted": {
    ru: "Скрыто: нет права users.billing.read.",
    en: "Hidden: no permission (users.billing.read).",
  },
  "admin.users.billing.plan": { ru: "Тариф", en: "Plan" },
  "admin.users.billing.subscription": { ru: "Подписка", en: "Subscription" },
  "admin.users.billing.noSubscription": {
    ru: "Подписки нет.",
    en: "No subscription.",
  },
  "admin.users.billing.period": { ru: "Период", en: "Period" },
  "admin.users.billing.quota": {
    ru: "Квота за текущий час",
    en: "Quota this hour",
  },
  "admin.users.billing.noQuota": { ru: "Расхода нет.", en: "No usage." },
  "admin.users.billing.packs": {
    ru: "Пакеты использования",
    en: "Usage packs",
  },
  "admin.users.billing.packRemaining": { ru: "осталось", en: "remaining" },
  "admin.users.billing.overrides": {
    ru: "Исключения прав",
    en: "Entitlement overrides",
  },
  "admin.users.billing.orders": { ru: "Заказы", en: "Orders" },
  "admin.users.billing.refunds": { ru: "Возвраты", en: "Refunds" },
  "admin.users.billing.noOrders": { ru: "Заказов нет.", en: "No orders." },
  "admin.users.billing.noRefunds": { ru: "Возвратов нет.", en: "No refunds." },
  "admin.users.billing.cost": {
    ru: "Стоимость моделей за 30 дн.",
    en: "Model cost, 30d",
  },
  "admin.users.billing.calls": { ru: "вызовов", en: "calls" },
  "admin.users.billing.col.order": { ru: "Заказ", en: "Order" },
  "admin.users.billing.col.kind": { ru: "Вид", en: "Kind" },
  "admin.users.billing.col.state": { ru: "Состояние", en: "State" },
  "admin.users.billing.col.stars": { ru: "Звёзды", en: "Stars" },
  "admin.users.billing.col.created": { ru: "Создан", en: "Created" },
  "admin.users.billing.ordersCaption": {
    ru: "Заказы пользователя",
    en: "User orders",
  },
  "admin.users.billing.refundsCaption": {
    ru: "Возвраты пользователя",
    en: "User refunds",
  },

  "admin.users.identities.title": {
    ru: "Внешние учётные записи",
    en: "Identities",
  },
  "admin.users.identities.redacted": {
    ru: "Скрыто: нет права users.pii.read.",
    en: "Hidden: no permission (users.pii.read).",
  },
  "admin.users.identities.caption": {
    ru: "Внешние учётные записи",
    en: "External identities",
  },
  "admin.users.identities.provider": { ru: "Провайдер", en: "Provider" },
  "admin.users.identities.state": { ru: "Проверка", en: "Verification" },
  "admin.users.identities.subject": { ru: "Идентификатор", en: "Subject" },
  "admin.users.identities.none": {
    ru: "Учётных записей нет.",
    en: "No identities.",
  },
} as const;
